<template lang="pug">
  .column(:class="columnWidthClass")
    slot
</template>

<script>

export default {
  name: 'Col',
  props: {
    m: Number,
    s: Number,
    xs: Number
  },
  data () {
    return {
      columnWidthClass: ''
    }
  },
  created () {
    this.getColumnClass()
    window.addEventListener('resize', this.getColumnClass)
  },
  methods: {
    getColumnClass () {
      let windowSize = window.innerWidth
      if (windowSize > 1010) {
        this.columnWidthClass = `is-${this.m}`
      } else if (windowSize > 768 && windowSize <= 1010) {
        this.columnWidthClass = `is-${this.s}`
      } else {
        this.columnWidthClass = `is-${this.xs}`
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@media screen and (max-width: 436px)
  .column.is-12
    padding-left: 0
    padding-right: 0
</style>



// WEBPACK FOOTER //
// src/components/Col.vue